export const isFunction = value => typeof value === 'function';

export const isString = value => typeof value === 'string';

export const isSymbol = value => typeof value === 'symbol';